import type { JawOutlineTooth, JawOutlineToothParams } from '@witmetrics/utils';
import { formatNumber } from '@witmetrics/utils/strings';
import { TEETH } from './constants';

export const classes = {
  dialog: 'w-[98vw] max-w-[1200px] min-w-[350px]',
  body: 'w-full pt-0 pb-6 overflow-auto text-grey-8 dark:text-mauve-1',
  title: 'text-base text-grey-8 dark:text-mauve-1 font-semibold p-2',
  cell: 'text-center capitalize',
  excludeMolar: 'mt-8 mx-4 flex gap-2 text-base',
};

export function buildRows(
  settings: Record<JawOutlineTooth, JawOutlineToothParams>
) {
  const types: string[] = [];
  const heights: string[] = [];
  const offsets: string[] = [];
  TEETH.forEach((tooth) => {
    types.push(settings[tooth].outlineType);
    heights.push(settings[tooth].outlineHeight);
    offsets.push(formatNumber(settings[tooth].outlineHeightOffset));
  });
  return { types, heights, offsets };
}
